import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

import markerShadow from 'leaflet/dist/images/marker-shadow.png';
import markervesselRun from 'assets/img/marker-vessel-jalan.svg';
import markervesselStop from 'assets/img/marker-vessel-berhenti.svg';
import markerDot from 'assets/img/dot_maps.png';


export const vesselRunPoint = new L.Icon({
  iconRetinaUrl: markervesselRun,
  shadowUrl: markerShadow,
  iconUrl: markervesselRun,
  iconAnchor: [20, 40],
  popupAnchor: [0, -35],
  iconSize: [40, 40],
  shadowSize: [29, 40],
  shadowAnchor: [7, 40],
})

export const vesselStopPoint = new L.Icon({
  iconRetinaUrl: markervesselStop,
  shadowUrl: markerShadow,
  iconUrl: markervesselStop,
  iconAnchor: [20, 40],
  popupAnchor: [0, -35],
  iconSize: [40, 40],
  shadowSize: [29, 40],
  shadowAnchor: [7, 40],
})

export const vesselDot = new L.Icon({
  iconRetinaUrl: markerDot,
  iconUrl: markerDot,
  iconAnchor: [0, 0],
  popupAnchor: [0, -15],
  iconSize: [10, 10],
  shadowSize: [29, 40],
  shadowAnchor: [7, 40],
})